import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot } from '@angular/router';
import { KeycloakAuthGuard, KeycloakEventTypeLegacy, KeycloakService } from 'keycloak-angular';
import { LoginService } from './login.service';
import { NotificationService } from './notification.service';
import { UserService } from './user.service';

@Injectable({
  providedIn: 'root',
})
export class AuthGuard extends KeycloakAuthGuard {
  constructor(
    override readonly router: Router,
    protected readonly keycloak: KeycloakService,
    protected readonly notificationService: NotificationService,
    private userService: UserService,
    private loginService: LoginService,
  ) {
    super(router, keycloak);
  }

  static subscribeToEvents = true;
  private refreshRetries = 0;
  private maxRetries = 3;

  public async isAccessAllowed(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    if (!this.authenticated) {
      await this.keycloak.login({
        redirectUri: window.location.origin,
      });
    }

    if (AuthGuard.subscribeToEvents) {
      AuthGuard.subscribeToEvents = false;

      this.loginService.login();

      this.userService.initLoggedInUsed();

      this.keycloak.keycloakEvents$.subscribe((event) => {
        if (event.type == KeycloakEventTypeLegacy.OnTokenExpired) {
          this.keycloak.updateToken();
        }

        if (event.type == KeycloakEventTypeLegacy.OnAuthRefreshError) {
          this.refreshRetries++;
          if (this.refreshRetries < this.maxRetries) {
            console.warn(`Token refresh failed, retry ${this.refreshRetries}/${this.maxRetries}`);
            setTimeout(() => this.keycloak.updateToken(), 1000 * this.refreshRetries);
          } else {
            console.error('Max token refresh retries exceeded, logging out');
            this.keycloak.logout();
          }
        }

        if (event.type == KeycloakEventTypeLegacy.OnAuthError) {
          this.keycloak.logout();
        }
      });
    }

    return this.authenticated;
  }
}
